import { render, staticRenderFns } from "./BrochureWidgetSmall.vue?vue&type=template&id=ee4ece42&scoped=true"
import script from "./BrochureWidgetSmall.vue?vue&type=script&lang=js"
export * from "./BrochureWidgetSmall.vue?vue&type=script&lang=js"
import style0 from "./BrochureWidgetSmall.vue?vue&type=style&index=0&id=ee4ece42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee4ece42",
  null
  
)

export default component.exports